<template>
  <!-- TOP MENU-->
  <div id="navbar">
    <nav class="navbar navbar-default navbar-fixed-top">
      <div class="container">
        <!-- Brand and toggle get grouped for better mobile display-->
        <div class="navbar-header">
          <button type="button" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false" class="navbar-toggle collapsed">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span>
          </button>
          <router-link to="/" class="navbar-brand logo" style="padding: 0 10px 0 ">
            <!-- <span class="domore-yellow">do</span>
            <span class="domore-blue-1">More</span>
            <span class="domore-blue-2">.live</span> -->
            <img style="width: 120px" src="~assets/img/logo2.png">
          </router-link>
        </div>
        <!-- Collect the nav links, forms, and other content for toggling-->
        <div id="bs-example-navbar-collapse-1" class="collapse navbar-collapse">
          <ul class="nav navbar-nav">
            <li>
              <router-link :to="{ name: 'crowdfunding'}">{{ $t("header.explore") }}</router-link>
            </li>
            <li><router-link to="/how_it_works">{{ $t("header.howItWorks") }}</router-link></li>
            <li><router-link to="/start_campaign">{{ $t("header.startCampaign") }}</router-link></li>
          </ul>
          <div class="col-sm-3 nav-search">
            <div class="input-group">
              <input v-model="search.title" type="text" placeholder="search projects" class="form-control"/>
                <span class="input-group-btn">
                  <button @click="findProjects()" type="button" class="btn btn-default">
                    <span aria-hidden="true" class="glyphicon glyphicon-search"></span>
                  </button>
                </span>
              </input>
            </div>
          </div>
          <ul v-if="!user.email" class="nav navbar-nav navbar-right">
            <li @click="fbLogin()"><a><i class="fa fa-facebook-official domore-blue-1"></i> {{ $t("header.connect") }}</a></li>
            <li><button @click="showSignup = true" class="btn-link">{{ $t("header.signupButton") }}</button></li>
            <li><button @click="showLogin = true" class="btn-link">{{ $t("header.loginButton") }}</button></li>
          </ul>
          <ul v-else class="nav navbar-nav navbar-right">
            <li class="user-nav">
              <router-link :to="{ name: 'edit_profile' }">{{ $t("header.yourProfile") }}</router-link>
                <ul>
                  <li class="user-link"><router-link :to="{ name: 'edit_profile', query: { tab: 'campaigns' }}">{{ $t("header.myCampaigns") }}</router-link></li>
                  <li class="user-link"><router-link :to="{ name: 'edit_profile', query: { tab: 'about' }}">{{ $t("header.aboutMe") }}</router-link></li>
                  <li class="user-link"><router-link :to="{ name: 'edit_profile', query: { tab: 'delivery-address' }}">{{ $t("header.delivery") }}</router-link></li>
                  <li class="user-link"><router-link :to="{ name: 'edit_profile', query: { tab: 'organization' }}">{{ $t("header.organization") }}</router-link></li>
                </ul>
            </li>
            <li><a href="#" @click="logout">{{ $t("header.logoutButton") }}</a></li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Modal Log In-->
    <login-modal v-if="showLogin" :close="closeLogin"></login-modal>
    <!-- Modal Sign Up-->
    <signup-modal v-if="showSignup" :close="closeSignup">
      <div slot="errors">
        <alert :error="error"></alert>
      </div>
    </signup-modal>

  </div>
</template>

<script>
import LoginModal from '@/components/Header/LoginModal';
import SignupModal from '@/components/Header/SignupModal';
import Alert from '@/components/Alert';
import auth from '@/api/v1/auth/authService';
import facebook from '@/api/facebook';

function logout() {
  auth.logout();
  this.user = auth.user;
}

export default {
  components: { LoginModal, SignupModal, Alert },
  data() {
    return {
      user: auth.user,
      showLogin: false,
      showSignup: false,
      search: {},
      error: '',
    };
  },
  methods: {
    logout,
    closeSignup() {
      this.showSignup = false;
    },
    closeLogin() {
      this.showLogin = false;
    },
    findProjects() {
      this.$router.push({ name: 'crowdfunding', query: this.search });
    },
    fbLogin() {
      const vm = this;
      function succ(accessToken) {
        auth.fbLogin(vm, accessToken);
      }
      facebook.login(succ);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?aa9a5b7c